<header [ngClass]="{ 'not-dashboard-not-mobile': !isDashboard && !isMobile }">
    <section class="top-bar">
        @if (isDashboard) {
            <img src="flexLogo.png" />
        } @else {
            <tui-icon [icon]="selectedProject$().icon" [style.color]="'white'"></tui-icon>
        }
        <h1 class="title">{{ selectedProject$().name }}</h1>
    </section>
    <section>
        @if (showMenu && isMobile) {
            <ffx-mobile-menu
                [isDarkMode]="theme$() === 'dark' ? true : false"
                (toggleDarkModeEvent)="toggleDarkMode()"
            ></ffx-mobile-menu>
        }
        @if (!isMobile || !showMenu) {
            <ffx-logout size="s"></ffx-logout>
        }
    </section>
</header>

@if (showProgressBar$()) {
    <div class="loading-bar"></div>
}

@if (showMenu) {
    <div class="content">
        @if (!isMobile) {
            <ffx-desktop-menu
                [isDarkMode]="theme$() === 'dark' ? true : false"
                [ngClass]="{ 'not-dashboard': !isDashboard }"
                (toggleDarkModeEvent)="toggleDarkMode()"
            ></ffx-desktop-menu>
        }
        <div class="content-router-outlet" [ngClass]="isMobile ? 'mobile' : 'desktop'">
            <router-outlet />
        </div>
    </div>
}
